// Legacy formatGBP utility - maintained for backward compatibility
// New implementations should use formatCurrency from './formatCurrency'

export const formatGBP = (value) =>
  new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'GBP',
    maximumFractionDigits: 0,
  }).format(value);